import { smartSignin } from '@creditas-lab/auth-sdk'

const validateUsername = username => {
  const isEmail = username.includes('@')
  if (isEmail) return username

  try {
    const onlyDigitsUsername = username.replace(/\D/g, '')
    return onlyDigitsUsername
  } catch (error) {
    return username
  }
}

const validateAccount = async username => {
  const { hasPassword, hasEmail, hasCellphone } = await smartSignin(username)
  return {
    hasPassword,
    hasEmail,
    hasCellphone,
    hasAccount: true,
  }
}

export const checkExistingUser = async username => {
  const validUsername = validateUsername(username)
  const accountData = await validateAccount(validUsername)

  if (accountData.hasAccount) {
    return {
      hasAccount: accountData.hasAccount,
      hasPassword: accountData.hasPassword,
      hasEmail: accountData.hasEmail,
      hasCellphone: accountData.hasCellphone,
    }
  }

  return null
}
